import React from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { Button, Box, Modal, styled } from '@goodrx/matisse';

import Collapsible from 'react-collapsible';
import Markdown from 'react-markdown';
import { LegalCodesToDisplayName } from 'app/config/constants';

const ListItem = styled.div`
  & + & {
    border-top: 1px solid ${(p) => p.theme.colors.greyLightest};
  }

  &:hover {
    background: ${(p) => p.theme.colors.greyLightest};
  }
`;

const MarkdownContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  background: ${(p) => p.theme.colors.greyLightest};
  padding: 12px;

  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 16px;
  }

  h3 {
    font-size: 14px;
  }
`;

export const LegalAgreementModal: React.FC = () => {
  const [legalsRequiringAgreement, agreeingToLegals, agreeToLegals] = useSynapse(({ user }) => [
    user.state.legalsRequiringAgreement,
    user.state.agreeingToLegals,
    user.agreeToLegals,
  ]);

  if (!legalsRequiringAgreement.length) return null;

  return (
    <Modal title="We've updated our user agreements and policies!" maxWidth={500} open={!!legalsRequiringAgreement}>
      <Modal.Body>
        {legalsRequiringAgreement.map((doc: any) => (
          <ListItem key={doc.code}>
            <Collapsible
              trigger={
                <Box p={12} style={{ cursor: 'pointer' }}>
                  + {LegalCodesToDisplayName[doc.code]}
                </Box>
              }>
              <MarkdownContainer>
                <Markdown source={doc.content} />
              </MarkdownContainer>
            </Collapsible>
          </ListItem>
        ))}

        <Button size="lg" block mt={3} variant="success" loading={agreeingToLegals} onClick={() => agreeToLegals()}>
          I Agree and Consent
        </Button>
      </Modal.Body>
    </Modal>
  );
};
